import { Link } from "react-router";

interface ErrorPageProps {
    onRetry?: () => void;
    message?: string;
}

export function ErrorPage({ onRetry, message }: ErrorPageProps) {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center p-4 text-center">
            <h1 className="mb-4 text-4xl font-bold">Something went wrong</h1>
            <p className="text-muted-foreground mb-6 max-w-xl text-lg">{message ?? "An unexpected error occurred while loading this page."}</p>
            <div className="flex flex-wrap items-center justify-center gap-3">
                {onRetry && (
                    <button
                        type="button"
                        onClick={onRetry}
                        className="inline-flex items-center justify-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
                    >
                        Try again
                    </button>
                )}
                <Link
                    to="/"
                    className="text-primary-foreground inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium hover:bg-primary/90"
                >
                    Go Home
                </Link>
            </div>
        </div>
    );
}
